import script from "./introduct.vue?vue&type=script&setup=true&lang=js"
export * from "./introduct.vue?vue&type=script&setup=true&lang=js"

import "./introduct.vue?vue&type=style&index=0&id=3a1c8e86&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a1c8e86"]])

export default __exports__